import React from 'react';
import { Stack, IStackTokens } from '@fluentui/react/lib/Stack';
import Header from '../header/header';
import Footer from '../footer/Footer';
import SideNavigation from '../navigation/SideNavigation';
import styles from './Layout.module.scss';

const stackTokens: IStackTokens = { childrenGap: 0 };
const Layout: React.FC = ({ children }) => {
    return (
        <Stack verticalFill horizontal className={styles.stackRoot}>
            <SideNavigation />

            <Stack verticalFill className={styles.stackRoot} tokens={stackTokens}>
                <Stack className={styles.headerFooterRoot}>
                    <Header />
                </Stack>

                <Stack grow className={styles.bodyRoot}>
                    {children}

                </Stack>
                <Stack className={styles.headerFooterRoot} verticalAlign='center'>
                    <Footer />
                </Stack>
            </Stack>

        </Stack>
    );
};

export default Layout;